import React from 'react';
import { Card } from 'antd';
import PropTypes from 'prop-types';
import PageHeader from './PageHeader';

const Page = ({ 
  title, 
  subtitle, 
  headerExtra, 
  children,
  withoutCard = false 
}) => {
  const content = withoutCard ? children : (
    <Card>{children}</Card>
  );

  return (
    <div>
      <PageHeader 
        title={title} 
        subtitle={subtitle} 
        extra={headerExtra} 
      />
      {content}
    </div>
  );
};

Page.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  headerExtra: PropTypes.node,
  children: PropTypes.node.isRequired,
  withoutCard: PropTypes.bool,
};

export default Page;
